// extracted by mini-css-extract-plugin
export default {"colorBlock":"SingleColorSelectOption-module-colorBlock-a1_jZ"};